export const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? 'http://127.0.0.1:8080'
  : process.env.REACT_APP_API_URL || 'https://interview-backend-88668928353.europe-west1.run.app';

export const INTERVIEW_CONFIG = {
  DEFAULT_INTERVIEW_TYPE: 'STANDARD_INTERVIEWS',
  SESSION_PREFIX: 'session_',
}; 

export const FIREBASE_CONFIG = {
  getCollectionPrefix: () => process.env.NODE_ENV === 'development' ? 'dev_' : '',
  INTERVIEW_COLLECTION: () => `${FIREBASE_CONFIG.getCollectionPrefix()}interview-sessions`,
} as const; 